var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback } from 'react';
import { apiUpdateProRfpShareDocumentMessage } from '@/actions/ProRfpShareDocumentActions';
import { messageFieldName, filesFieldName, } from '@/components/modules/Chat/ChatForm';
import { notify } from '@/helpers/action';
import { wrapDispatch } from '@/utils/actions/dispatch';
import { RFP_SHARE_DOCUMENT_MESSAGE_STATUS_DRAFT, RFP_SHARE_DOCUMENT_MESSAGE_STATUS_PUBLIC, } from '@/utils/constants/rfp/rfpShareDocument/rfpShareDocumentMessage/status';
/**
 * ファイル共有メッセージの更新処理
 */
export const useRfpProfessionalFileSubmit = (options) => {
    const { dispatch, fetchFileShare, id, unmountRef } = options;
    /**
     * メッセージ送信
     */
    const onSubmit = useCallback((formValues, form) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        // ファイル情報を整形
        const files = ((_a = formValues === null || formValues === void 0 ? void 0 : formValues.files) === null || _a === void 0 ? void 0 : _a.map((file) => ({
            // 既存のファイルID
            file_id: file.id === null ? undefined : file.id,
            // 新たにアップロードされたファイルID
            new_file_id: file.new_file_id === null ? undefined : file.new_file_id,
        }))) || [];
        // APIを実行
        yield wrapDispatch(dispatch, apiUpdateProRfpShareDocumentMessage({
            json: {
                files,
                message: formValues.description || '',
                status: formValues.isDraft
                    ? RFP_SHARE_DOCUMENT_MESSAGE_STATUS_DRAFT.value
                    : RFP_SHARE_DOCUMENT_MESSAGE_STATUS_PUBLIC.value,
            },
            path: { id },
        }, {}));
        if (!unmountRef.current) {
            if (!formValues.isDraft) {
                // フォームの値をリセット
                form.batch(() => {
                    var _a, _b;
                    form.change(messageFieldName, '');
                    form.change(filesFieldName, []);
                    (_a = form.resetFieldState) === null || _a === void 0 ? void 0 : _a.call(form, messageFieldName);
                    (_b = form.resetFieldState) === null || _b === void 0 ? void 0 : _b.call(form, filesFieldName);
                });
                // トースト表示（送信用）
                notify(RFP_SHARE_DOCUMENT_MESSAGE_STATUS_PUBLIC.message);
            }
            else {
                // トースト表示（下書き用）
                notify(RFP_SHARE_DOCUMENT_MESSAGE_STATUS_DRAFT.message);
            }
            // ファイル共有の関するデータ引き直し
            yield fetchFileShare(dispatch, { id }, unmountRef);
        }
    }), [dispatch, fetchFileShare, id, unmountRef]);
    return {
        onSubmit,
    };
};
